import React, { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import "./styles/PaymentSuccess.css";

const PaymentSuccess = () => {

    const [searchParams] = useSearchParams();
    const navigate = useNavigate();

    const orderId = searchParams.get("order_id");

    const [receipt, setReceipt] = useState(null);
    const [countdown, setCountdown] = useState(20);
    const [loading, setLoading] = useState(true);

    useEffect(() => {

        fetch(
            `/gt-api/get_receipt.php?order_id=${orderId}`
        )
            .then((res) => res.json())
            .then((data) => {

                if (data.success) {
                    setReceipt(data.receipt);
                }

                setLoading(false);
            })
            .catch(() => {
                setLoading(false);
            });

    }, [orderId]);

    useEffect(() => {

        const timer = setInterval(() => {

            setCountdown((prev) => {

                if (prev <= 1) {

                    clearInterval(timer);

                    navigate("/");

                    return 0;
                }

                return prev - 1;
            });

        }, 1000);

        return () => clearInterval(timer);

    }, [navigate]);

    if (loading) {
        return <div>Loading Receipt...</div>;
    }

    return (
        <div className="successpaymenttrue-page">

            <div className="successpaymenttrue-card">

                <div className="successpaymenttrue-header">
                    <h1>Payment Successful</h1>
                    <p>Your subscription has been activated.</p>
                </div>

                {receipt && (
                    <>
                        <div className="successpaymenttrue-row">
                            <span>Order ID</span>
                            <span>{receipt.cashfree_order_id}</span>
                        </div>

                        <div className="successpaymenttrue-row">
                            <span>Organization</span>
                            <span>{receipt.org_name}</span>
                        </div>

                        <div className="successpaymenttrue-row">
                            <span>Email</span>
                            <span>{receipt.company_email}</span>
                        </div>

                        <div className="successpaymenttrue-row">
                            <span>Plan</span>
                            <span>{receipt.selected_plan}</span>
                        </div>

                        <div className="successpaymenttrue-row">
                            <span>Duration</span>
                            <span>{receipt.selected_months} Months</span>
                        </div>

                        <div className="successpaymenttrue-row">
                            <span>Employees</span>
                            <span>{receipt.employee_count}</span>
                        </div>

                        <div className="successpaymenttrue-row">
                            <span>Total Amount</span>
                            <span>₹{receipt.total_amount}</span>
                        </div>

                        <div className="successpaymenttrue-row">
                            <span>GST Number</span>
                            <span>
                                {receipt.gst_number || "Not Provided"}
                            </span>
                        </div>

                        <div className="successpaymenttrue-row">
                            <span>Status</span>
                            <span>{receipt.payment_status}</span>
                        </div>

                        <div className="successpaymenttrue-row">
                            <span>Date</span>
                            <span>{receipt.created_at}</span>
                        </div>
                    </>
                )}

                <div className="successpaymenttrue-countdown-box">
                    Redirecting to homepage in
                    <strong> {countdown} </strong>
                    seconds...
                </div>

            </div>

        </div>
    );
};

export default PaymentSuccess;